import OnecloudOrganizationTenantHandler from './OnecloudOrganizationTenantHandler';
import CustomerTenantHandler from './CustomerTenantHandler';
import OrganizationTenantHandler from './OrganizationTenantHandler';
import TenantStrategy from './TenantStrategy';
import { TenantStrategyEnum } from './TenantStrategyEnum';
import { TenantHandlerStrategyType } from './types';
import AstBasedTenantHandler from './AstBasedTenantHandler';

export { TenantStrategyEnum };

const getTenantStrategy = (
  strategy: TenantStrategyEnum,
  attributes: Omit<TenantHandlerStrategyType, 'parentAuthProvider'>
): TenantStrategy => {
  let tenantStrategy: TenantStrategy;
  if (attributes?.isAST) {
    const tenantAuthProvider = attributes?.authProvider;
    const parentAuthProvider =
      attributes?.authProvider?.createOrglessAuthProvider();

    tenantStrategy = new AstBasedTenantHandler({
      ...attributes,
      authProvider: tenantAuthProvider,
      parentAuthProvider
    });
  } else if (strategy == TenantStrategyEnum.stratusOrganization) {
    const tenantAuthProvider = attributes?.authProvider;
    const parentAuthProvider =
      attributes?.authProvider?.createOrglessAuthProvider();

    tenantStrategy = new OrganizationTenantHandler({
      ...attributes,
      authProvider: tenantAuthProvider,
      parentAuthProvider
    });
  } else if (strategy === TenantStrategyEnum.stratusCustomer) {
    const tenantAuthProvider = attributes?.authProvider;
    const parentAuthProvider =
      attributes?.authProvider?.createOrgedAuthProvider();

    tenantStrategy = new CustomerTenantHandler({
      ...attributes,
      authProvider: tenantAuthProvider,
      parentAuthProvider
    });
  } else if (strategy == TenantStrategyEnum.onecloudOrganization) {
    const tenantAuthProvider = attributes?.authProvider;

    tenantStrategy = new OnecloudOrganizationTenantHandler({
      ...attributes,
      authProvider: tenantAuthProvider
    });
  } else {
    throw new Error("Tenant strategy doesn't exists.");
  }
  return tenantStrategy;
};

export default getTenantStrategy;
